import React from "react";

const Copy = (props: any) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.7703 16.8H0.299164C0.199439 16.8 0 16.7 0 16.5V0.5C0 0.4 0.0997132 0.200012 0.299164 0.200012H10.7703C10.8701 0.200012 11.0695 0.3 11.0695 0.5V4.10001C11.0695 4.20001 10.9698 4.39999 10.7703 4.39999C10.6706 4.39999 10.4712 4.30001 10.4712 4.10001V0.700012H0.498627V16.1H10.4712V5.70001C10.4712 5.60001 10.5709 5.39999 10.7703 5.39999C10.8701 5.39999 11.0695 5.50001 11.0695 5.70001V16.5C10.9698 16.6 10.8701 16.8 10.7703 16.8Z"
        fill="black"
      />
      <path
        d="M0.299164 2.70001C0.199439 2.70001 0 2.59999 0 2.39999V2.29999C0 2.19999 0.0997132 2 0.299164 2C0.398889 2 0.598358 2.09999 0.598358 2.29999V2.39999C0.498633 2.59999 0.398889 2.70001 0.299164 2.70001Z"
        fill="black"
      />
      <path
        d="M9.47391 2.69998H0.299164C0.199439 2.69998 0 2.59996 0 2.39996C0 2.29996 0.0997132 2.09998 0.299164 2.09998H9.47391C9.57364 2.09998 9.77308 2.19996 9.77308 2.39996C9.77308 2.59996 9.57364 2.69998 9.47391 2.69998Z"
        fill="black"
      />
      <path
        d="M10.4714 13.5H1.59583C1.4961 13.5 1.29663 13.4 1.29663 13.2C1.29663 13.1 1.39637 12.9 1.59583 12.9H10.4714C10.5711 12.9 10.7705 13 10.7705 13.2C10.7705 13.4 10.6708 13.5 10.4714 13.5Z"
        fill="black"
      />
      <path
        d="M6.28284 15.1001H4.58752C4.4878 15.1001 4.28833 15 4.28833 14.8C4.28833 14.7 4.38807 14.5001 4.58752 14.5001H6.28284C6.38256 14.5001 6.58203 14.6 6.58203 14.8C6.48231 15 6.38256 15.1001 6.28284 15.1001Z"
        fill="black"
      />
    </svg>
  );
};

export default Copy;
